module.exports = "../../../../platform/assets/pageMainIcon/simple_jichudanganlei6.svg";